import React from 'react';
import { RenewalOptions } from '../../components/renewal-options';

export const RenewalOptionsPage: React.FC = () => {
    return <RenewalOptions />;
};
